import { api } from './apiClient';

export const fetchModuleList = async (page = 1, limit = 10, search = '', filters = {}, extra = {}) => {
  try {
    const requestBody = {
      page,
      limit,
      searchtext: search,
      filters,
    };
    if (extra.tags) {
      requestBody.pagination = {
        filters: { tags: extra.tags },
      };
    }

    const response = await api.post('/api/v1/admin/modules/list', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const createModule = async (moduleData) => {
  try {
    const requestBody = {
      title: moduleData.title,
      description: moduleData.description,
      thumbnail_url: moduleData.thumbnail_url || '',
      order: moduleData.order || 1,
      tags: Array.isArray(moduleData.tags) ? moduleData.tags : [],
      grouping_ids: Array.isArray(moduleData.grouping_ids) ? moduleData.grouping_ids : [],
    };

    const response = await api.post('/api/v1/admin/modules', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const updateModule = async (moduleData) => {
  try {
    const requestBody = {
      module_id: moduleData.module_id,
      title: moduleData.title,
      description: moduleData.description,
      thumbnail_url: moduleData.thumbnail_url || '',
      order: moduleData.order || 1,
      is_active: moduleData.is_active !== undefined ? moduleData.is_active : true,
    };
    if (moduleData.tags !== undefined) {
      requestBody.tags = Array.isArray(moduleData.tags) ? moduleData.tags : [];
    }
    if (moduleData.grouping_ids !== undefined) {
      requestBody.grouping_ids = Array.isArray(moduleData.grouping_ids) ? moduleData.grouping_ids : [];
    }

    const response = await api.put('/api/v1/admin/modules', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const deleteModule = async (moduleId) => {
  try {
    const response = await api.delete(`/api/v1/admin/modules/${moduleId}`);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

